import React from 'react';
import { Link } from 'react-router-dom';

const InstagramIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <radialGradient id="ig" cx="30%" cy="107%" r="150%">
        <stop offset="0%" stopColor="#fdf497"/>
        <stop offset="45%" stopColor="#fd5949"/>
        <stop offset="60%" stopColor="#d6249f"/>
        <stop offset="90%" stopColor="#285AEB"/>
      </radialGradient>
    </defs>
    <rect width="24" height="24" rx="6" fill="url(#ig)"/>
    <circle cx="12" cy="12" r="4.2" stroke="white" strokeWidth="1.8" fill="none"/>
    <circle cx="17.5" cy="6.5" r="1.2" fill="white"/>
  </svg>
);

const FacebookIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="6" fill="#1877F2"/>
    <path d="M16 8h-2a1 1 0 00-1 1v2h3l-.5 3H13v7h-3v-7H8v-3h2V9a4 4 0 014-4h2v3z" fill="white"/>
  </svg>
);

const XIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="6" fill="#000"/>
    <path d="M17.5 4h2.5l-5.5 6.3L21 20h-5l-3.6-4.7L8 20H5.5l5.8-6.7L4 4h5.1l3.3 4.3L17.5 4zm-.9 14.4h1.4L7.5 5.4H6L16.6 18.4z" fill="white"/>
  </svg>
);

const services = [
  {
    title: 'Web Development',
    icon: (
      <div className="svc-icon-row">
        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" alt="React" width="40" height="40" />
        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" alt="JS" width="40" height="40" />
        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg" alt="HTML" width="40" height="40" />
        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg" alt="CSS" width="40" height="40" />
      </div>
    ),
    desc: 'Building responsive and modern web applications with the latest technologies.',
    techs: ['React', 'JavaScript', 'HTML', 'CSS'],
  },
  {
    title: 'Graphic Design',
    icon: (
      <div className="svc-icon-row">
        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/canva/canva-original.svg" alt="Canva" width="40" height="40" />
        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg" alt="Figma" width="40" height="40" />
        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/illustrator/illustrator-plain.svg" alt="Illustrator" width="40" height="40" />
      </div>
    ),
    desc: 'Creating stunning visual designs and brand identities that leave lasting impressions.',
    techs: ['Adobe Illustrator', 'Canva', 'Figma'],
  },
  {
    title: 'Social Media Marketing',
    icon: (
      <div className="svc-icon-row">
        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linkedin/linkedin-original.svg" alt="LinkedIn" width="40" height="40" />
        <InstagramIcon />
        <FacebookIcon />
        <XIcon />
      </div>
    ),
    desc: 'Building brand presence and engaging audiences across platforms with strategic content.',
    techs: ['Content Strategy', 'Analytics', 'Branding'],
  },
  {
    title: 'Data Analysis',
    icon: (
      <div className="svc-icon-row">
        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" alt="Python" width="40" height="40" />
        <img src="https://upload.wikimedia.org/wikipedia/commons/3/34/Microsoft_Office_Excel_%282019%E2%80%93present%29.svg" alt="Excel" width="40" height="40" />
        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pandas/pandas-original.svg" alt="Pandas" width="40" height="40" />
      </div>
    ),
    desc: 'Transforming raw data into actionable insights and clear visualizations.',
    techs: ['Python', 'Excel', 'Data Visualization'],
  },
  {
    title: 'Project Management',
    icon: (
      <div className="svc-icon-row">
        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/trello/trello-plain.svg" alt="Trello" width="40" height="40" />
        <img src="https://upload.wikimedia.org/wikipedia/commons/4/45/Notion_app_logo.png" alt="Notion" width="40" height="40" style={{objectFit:'contain'}} />
        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jira/jira-original.svg" alt="Jira" width="40" height="40" />
      </div>
    ),
    desc: 'Leading teams and managing projects from concept to successful delivery.',
    techs: ['Agile', 'Planning', 'Leadership'],
  },
  {
    title: 'Communication',
    icon: (
      <div className="svc-icon-row">
        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/slack/slack-original.svg" alt="Slack" width="40" height="40" />
        <img src="https://upload.wikimedia.org/wikipedia/commons/4/45/Notion_app_logo.png" alt="Notion" width="40" height="40" style={{objectFit:'contain'}} />
        <img src="https://upload.wikimedia.org/wikipedia/commons/a/ab/Gmail_Icon_512px.png" alt="Gmail" width="40" height="40" style={{objectFit:'contain'}} />
      </div>
    ),
    desc: 'Effective communication strategies and stakeholder engagement for impactful outcomes.',
    techs: ['Public Speaking', 'Writing', 'Strategy'],
  },
];

function Services() {
  return (
    <div className="page-wrapper">
      <section className="page-hero">
        <div className="page-hero-overlay"></div>
        <div className="page-hero-content">
          <h1 className="page-hero-title">My Services</h1>
          <p className="page-hero-subtitle">Delivering excellence across multiple domains</p>
        </div>
      </section>

      <section className="page-section">
        <div className="page-container">
          <h2 className="page-section-title">What I Offer</h2>
          <div className="services-pro-grid">
            {services.map((s, i) => (
              <div key={i} className="service-pro-card">
                <div className="service-pro-icon-wrap">{s.icon}</div>
                <div className="service-pro-body">
                  <h3 className="service-pro-title">{s.title}</h3>
                  <p className="service-pro-desc">{s.desc}</p>
                  <div className="service-pro-techs">
                    {s.techs.map((t, j) => <span key={j} className="tech-chip">{t}</span>)}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="cta-banner">
            <h2>Ready to Work Together?</h2>
            <p>Let's discuss how I can help bring your project to life.</p>
            <Link to="/contact" className="cta-btn">Get In Touch</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Services;
